export const ES = "es";
export const EN = "en";
